<template>
  <template v-if="jorfsStore.items.length">
    <!-- Cards -->
    <div class="responsive-cards-wrapper">
      <JorfCard
        v-for="jorf in jorfsStore.items"
        :key="jorf._id"
        v-focus
        :jorf="jorf"
      ></JorfCard>
    </div>

    <!-- Pagination -->
    <PaginationElement
      v-if="jorfsStore.item_count"
      :key="`${jorfsStore.item_count}${jorfsStore.selectedFilters.from}${jorfsStore.selectedFilters.size}`"
      :total-items="jorfsStore.item_count"
      :current-page="jorfsStore.selectedFilters.from"
      :items-limit="jorfsStore.selectedFilters.size"
      @change-current-page="changeCurrentPage"
    />
  </template>
  <template v-else>
    <NoData v-if="jorfsStore.hasActiveFilters" />
    <NoDataFollawed v-else-if="jorfsStore.isFollawedActive" />
    <NoData v-else />
  </template>
</template>

<script setup>
import JorfCard from "../atoms/JorfCard.vue";
import PaginationElement from "@follaw-fr/components/reusable/atoms/PaginationElement.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";
import NoDataFollawed from "@follaw-fr/components/reusable/atoms/NoDataFollawed.vue";

import { useJorfsStore } from "@follaw-fr/stores/jorfs";

const jorfsStore = useJorfsStore();
const changeCurrentPage = (from) => {
  jorfsStore.selectedFilters.from = from;
  jorfsStore.fetchJorfsList();
};
</script>
